import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./opsvaTerritory"

export default {
	updateField,
	SET_OPSVA_TERRITORIES(state, payload) {
		state.opsva_territories = payload
	},
	SET_OPSVA_TERRITORY(state, payload) {
		state.opsva_territory = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_opsva_territory[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_opsva_territory) {
			state.validation_opsva_territory[key] = null
		}
	},
}
